import { render, staticRenderFns } from "./custom-service-params.vue?vue&type=template&id=1d527b8c&scoped=true&"
import script from "./custom-service-params.vue?vue&type=script&lang=js&"
export * from "./custom-service-params.vue?vue&type=script&lang=js&"
import style0 from "./custom-service-params.vue?vue&type=style&index=0&id=1d527b8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d527b8c",
  null
  
)

export default component.exports